<template>
    <v-dialog v-model="show" max-width="390" persistent no-click-animation>
        <div class="ScenarioCreatorNew">
            <div class="dialog-header">
                <div>{{ scenario ? "Bot Editor" : "Bot Creator" }}</div>
                <v-btn flat icon @click="close()">
                    <v-icon>close</v-icon>
                </v-btn>
            </div>
            <div class="dialog-content" style="height: 60px">
                <v-radio-group v-model="nlpType" row :disabled="scenario !== null">
                    <v-radio label="Chatbot" value="chatbot"></v-radio>
                    <v-radio label="NLP Platform" value="nlp-platform"></v-radio>
                </v-radio-group>
            </div>
            <v-form v-model="formValid" ref="form" @submit="submit" style="padding: 12px">
                <!-- Chatbot -->
                <div v-if="nlpType==='chatbot'">
                    <div class="mb-12" v-if="nlpName">
                        <div class="label">{{ $t('treeNode.setting.currentNlp') }}</div>
                        <div style="font-size: 14px;">{{ nlpName }}</div>
                    </div>
                    <div class="label">NLP</div>
                    <v-autocomplete
                        outlined
                        v-model="model.nlp"
                        :items="nlpList"
                        item-text="name"
                        item-value="code"
                        class="input-custom"
                        :rules="formRules.required"
                        style="margin-bottom: 12px"
                    ></v-autocomplete>
                    <div class="label">{{ $f.tc('name') }}</div>
                    <v-text-field
                        outlined
                        v-model="model.name"
                        :rules="formRules.required"
                        class="input-custom"
                    ></v-text-field>
                    <v-checkbox
                        hide-details
                        v-model="enableNLPConfig"
                        color="#0052CC"
                        :label="$f.tc('enableNLPConfig')"
                        v-if="!isEditing"
                    ></v-checkbox>
                </div>
                <!-- NLP Platform -->
                <div v-else>
                    <div class="mb-12" v-if="nlpName">
                        <div class="label">{{ $t('treeNode.setting.currentNlp') }}</div>
                        <div style="font-size: 14px;">{{ nlpName }}</div>
                    </div>
                    <div class="label">Tenant name</div>
                    <div class="centerY mb-12">
                        <v-text-field
                            outlined
                            v-model="tenantName"
                            :rules="formRules.required"
                            class="input-custom"
                            :disabled="scenario !== null"
                        ></v-text-field>
                        <div class="btn-icon ml-6 mr-6">
                            <v-icon color="#96ADD0" size="26" @click="fetchNlus(false)">refresh</v-icon>
                            <v-progress-circular
                                v-if="isFetchingNlu"
                                color="#0052CC"
                                indeterminate
                                size="26"
                                style="width: 80px;"
                            ></v-progress-circular>
                        </div>
                    </div>
                    <div class="label">NLP</div>
                    <v-autocomplete
                        outlined
                        v-model="model.nlp"
                        :items="nluList"
                        item-text="name"
                        item-value="name"
                        class="input-custom"
                        :rules="formRules.required"
                        style="margin-bottom: 12px"
                        :disabled="!nluList || nluList.length === 0"
                    ></v-autocomplete>
                    <div class="label">{{ $f.tc('name') }}</div>
                    <v-text-field
                        outlined
                        v-model="model.name"
                        :rules="formRules.required"
                        class="input-custom"
                    ></v-text-field>
                </div>
            </v-form>
            <div class="dialog-footer">
                <div class="btn-custom"
                     @click="submit">{{ (scenario ? $f.tc('save') : $f.tc('create')) }}
                </div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import ScenarioService from "@/services/scenario.service";
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin";
import {mapState} from "vuex";

export default {
    name: "ScenarioCreatorNew",
    mixins: [DialogPromiseFormMixin],
    data() {
        return {
            nlpName: '',
            model: {
                nlp: '',
                name: '',
            },
            enableNLPConfig: true,
            scenario: null,
            isEditing: false,
            nlpType: 'chatbot',
            tenantName: '',
            isFetchingNlu: false,
        }
    },
    computed: {
        ...mapState({
            nlpList: state => state.campaign.bots,
            nluList: state => state.campaign.nlus,
        })
    },
    mounted() {
        this.$store.dispatch(this.$actionTypes.campaign.GET_BOTS)
    },
    methods: {
        open(scenario) {
            this.clearForm()
            this.scenario = scenario
            if (scenario) {
                this.isEditing = true
                let parts = this.scenario.nlp['code'].split('/')
                if (parts.length > 1) {
                    this.nlpType = 'nlp-platform'
                    this.tenantName = parts[6]
                    this.fetchNlus()
                }
                if (this.nlpType === 'chatbot') {
                    this.model = {
                        name: scenario.name,
                        nlp: scenario.nlp ? scenario.nlp.code : ''
                    }
                } else {
                    this.model = {
                        name: scenario.name,
                        nlp: scenario.nlp ? scenario.nlp.name : ''
                    }
                }
                this.nlpName = scenario.nlp ? scenario.nlp.name : ''
            } else {
                this.isEditing = false
            }
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        clearForm() {
            this.$refs.form.resetValidation()
            this.nlpName = ''
            this.model = {
                nlp: '',
                name: '',
            }
            this.enableNLPConfig = true
            this.nlpType = 'chatbot'
            this.tenantName = ''
            this.$store.commit(this.$actionTypes.campaign.SET_NLUS, [])
        },
        submitValidForm() {
            let model = {}
            if (this.nlpType === 'chatbot') {
                model = {
                    nlp: this.nlpList.find(item => item.code === this.model.nlp),
                    name: this.model.name
                }
            } else {
                model = {
                    nlp: this.nluList.find(item => item.name === this.model.nlp),
                    name: this.model.name
                }
            }
            this.$appService.showLoading()

            // update scenario
            if (this.scenario) {
                this.updateScenario(model)
                return
            }

            // create new scenario
            this.createScenario(model)
        },
        updateScenario(model) {
            let i18n = {
                action: this.$t('update'),
                item: this.$t('scenario')
            }
            ScenarioService.CRUD.update(this.scenario.id, model).then(
                () => {
                    this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                    this.close()
                    this.promise.resolve()
                },
                this.$appService.handleRequestError(this.$t('actionFailed', i18n))
            ).finally(this.$appService.hideLoading)
        },
        createScenario(model) {
            let i18n = {
                action: this.$t('create'),
                item: this.$t('scenario')
            }
            model.fallback = {
                type: 'end call',
                content: {
                    prompt: 'Xin lỗi em nghe không rõ, em xin phép ngắt máy và gọi lại sau',
                    phone_number: ''
                }
            }
            model.version = this.enableNLPConfig ? 2 : 1
            model.version = this.nlpType === 'nlp-platform' ? 3 : model.version
            ScenarioService.CRUD.create(model).then(
                result => {
                    this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                    this.close()
                    this.promise.resolve(result.data)
                },
                this.$appService.handleRequestError(this.$t('actionFailed', i18n))
            ).finally(this.$appService.hideLoading)
        },
        fetchNlus(isAuto = true) {
            if (!this.tenantName) {
                this.$appService.toastError(this.$t('tenantNameRequired'))
                return
            }
            let data = {
                tenantName : this.tenantName,
                isAuto : isAuto
            }
            this.$store.dispatch(this.$actionTypes.campaign.GET_NLUS, data)
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioCreatorNew {
    background: #FFFFFF;
    position: relative;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-header {
        padding: 0 0 0 12px;
    }

    .label {
        font-family: "open sans bold", serif;
        font-size: 13px;
        margin-bottom: 2px !important;
    }
}

.btn-custom {
    margin-right: 8px;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;
            outline: none;
            outline-offset: 0;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 9px
    }

    .v-select {
        .v-text-field__details {
            right: 28px !important;
        }

        &.input-custom {
            .v-input__slot {
                padding-right: 2px !important;
            }
        }
    }

    .input-custom:has(.error--text) {
        .v-input__slot {
            border-color: #ff5252 !important;
        }
    }

    .input-custom.v-input--is-focused {
        .v-input__slot {
            outline: 2px solid #FF52526B;
        }

        &:not(.error--text) {
            .v-input__slot {
                outline: 2px solid #0052CC6B;
                border-color: #0052CC !important;
            }
        }
    }

    .v-input--selection-controls__ripple {
        width: 0 !important;
        height: 0 !important;
    }

    .v-label {
        font-family: "open sans", serif !important;
        font-size: 14px !important;
        color: #000;
    }

    .v-input--selection-controls {
        margin-top: 14px !important;
        padding-top: 0 !important;
    }
}
</style>
